import { naturalSortListByAttribute } from "@pdpp/lib-planta";
import type { SearchableSelectOption } from "@pdpp/lib-react";

import { COUNTRY_NAME_BY_CODE } from "./transforms";
import type { GetOrgUnitsResponse, OrgUnit } from "./types";

const getCountryDisplayName = (countryCode: string): string =>
  COUNTRY_NAME_BY_CODE.get(countryCode) ?? countryCode;

const toUnitOption = (
  unit: OrgUnit,
  countryCode: string,
): SearchableSelectOption => ({
  value: String(unit.id),
  label: `${unit.name} (${unit.extType ?? ""}${unit.extId ?? ""})`,
  group: getCountryDisplayName(countryCode),
  keywords: [unit.extId ?? "", unit.extType ?? "", countryCode],
});

export const toUnitSelectOptions = (
  countries: ReadonlyArray<GetOrgUnitsResponse>,
): ReadonlyArray<SearchableSelectOption> => {
  const sortedCountries = [...countries].sort((left, right) =>
    getCountryDisplayName(left.countryCode).localeCompare(
      getCountryDisplayName(right.countryCode),
    ),
  );

  return sortedCountries.flatMap((country) =>
    naturalSortListByAttribute([...country.units], "name").map((unit) =>
      toUnitOption(unit, country.countryCode),
    ),
  );
};
